import { HelpOutline } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../../components/navigation/_paths";
import useFeature from "../../../../../hooks/useFeature";
import { useTaskContext } from "../../../hooks";
import { TaskForm, TaskSideSectionEditorProps } from "../../../types";

const FormSideSectionEditor = ({
  task,
}: TaskSideSectionEditorProps<TaskForm>) => {
  const navigate = useNavigate();
  const { setValue } = useTaskContext();
  const wizardFormatAvailable = useFeature("forms.formWizard");
  return (
    <>
      <Grid item xs={12}>
        <FormControlLabel
          control={<Checkbox checked={!!task.data?.autofill} />}
          onChange={(event: React.BaseSyntheticEvent) => {
            setValue({
              data: {
                ...task.data,
                autofill: event.target.checked ? true : undefined,
              },
            });
          }}
          label="Auto-fill with execution data"
        />
        <FormControlLabel
          control={<Checkbox checked={!!task.data?.processWithAi} />}
          onChange={(event: React.BaseSyntheticEvent) => {
            setValue({
              data: {
                ...task.data,
                processWithAi: event.target.checked ? true : undefined,
              },
            });
          }}
          label="Invoke Process from this task with Copilot"
        />
        {wizardFormatAvailable && (
          <FormControlLabel
            control={<Checkbox checked={!!task.data?.isWizard} />}
            onChange={(event: React.BaseSyntheticEvent) => {
              setValue({
                data: {
                  ...task.data,
                  isWizard: event.target.checked ? true : undefined,
                },
              });
            }}
            label={
              <>
                Use Wizard Format
                <Tooltip title="The wizard format displays the form in a step-by-step manner, making it easier for users to fill out complex forms.">
                  <IconButton size="small" sx={{ marginLeft: 1 }}>
                    <HelpOutline fontSize="small" />
                  </IconButton>
                </Tooltip>
              </>
            }
          />
        )}
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          fullWidth
          onClick={() => {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            navigate(PATHS.PROCESS_TASK.linkTo(task.process_id, task.id!));
          }}
        >
          {task.data?.form && task.data?.form?.elements.length > 0
            ? "View/Edit Form"
            : "Build Form"}
        </Button>
      </Grid>
    </>
  );
};

export default FormSideSectionEditor;
